export const trasladosTypes = {
  getSolicitud: '[TRASLADOS] getSolicitudTraslados',
  cleanSolicitud: '[TRASLADOS] cleanSolicitudTraslados',

  cleanSolicitudes: '[TRASLADOS] cleanSolicitudesTraslados',
  getSolicitudes: '[TRASLADOS] getSolicitudesTraslados',
  getInfoAfiliadoSolicitud: '[TRASLADOS] getInfoAfiliado',
  getAllSolicitudesTomadas: '[TRASLADOS] getSolicitudesTomadas',
  getByUserSolicitudesTomadas: '[TRASLADOS] getSolicitudesTomadasPorUsuario',
  getTrackingSolicitud: '[TRASLADOS] getTrackingSolicitudPorId',
  cleanTrackingSolicitud: '[TRASLADOS] cleanTrackingSolicitud',
  postSolicitudTomada: '[TRASLADOS] postSolicitudTomada',
  deleteSolicitudTomada: '[TRASLADOS] deleteSolicitudTomada',
  cambiarEstadoSolicitud: '[TRASLADOS] cambiarEstadoSolicitud',
  deleteSolicitudEnCarga: '[TRASLADOS] deleteSolicitudEnCarga',

  getNotasTraslado: '[TRASLADOS] getNotasTraslado',
  postNotaTraslado: '[TRASLADOS] postNotaTraslado',
  putNotaTraslado: '[TRASLADOS] putNotaTraslado',
  deleteNotaTraslado: '[TRASLADOS] deleteNotaTraslado',

  getTipoDocSolicitudes: '[TRASLADOS] getTipoDocSolicitudes',
  cleanTipoDocSolicitudes: '[TRASLADOS] cleanTipoDocSolicitudes',
  postTipoDocSolicitudes: '[TRASLADOS] postTipoDocSolicitudes',
  putTipoDocSolicitudes: '[TRASLADOS] putTipoDocSolicitudes',
  deleteTipoDocSolicitudes: '[TRASLADOS] deleteTipoDocSolicitudes',

  //DIM
  getTiposTraslados: '[TRASLADOS] getTiposTraslados',
  getAccesorios: '[TRASLADOS] getAccesorios',
  getCausasTraslados: '[TRASLADOS] getCausasTraslados',
  getMotivosTraslados: '[TRASLADOS] getMotivosTraslados',
  getSectoresTraslados: '[TRASLADOS] getSectoresTraslados',
  getTipoSolicitudes: '[TRASLADOS] getTipoSolicitudesTraslados',
  getEstados: '[TRASLADOS] getEstadosTraslados',
  getCodigos: '[TRASLADOS] getCodigosTraslados',
  getTipoPrestaciones: '[TRASLADOS] getTipoPrestacionesTraslados',
  getTipoTracking: '[TRASLADOS] getTipoTrackingTraslados',
};
